import React, {
    useRef,
    forwardRef,
} from "react";
import TextEditor, { TextEditorRef } from "./Editor";


type EditorViewProps = {
    viewType?: "editor" | string; // same semantics as Vue prop
    toggleView?: () => void;
    editorView?: any; // kept for compatibility
    savedContent?: string;
    // Optional callbacks to mirror Vue $emit
    loadEditor?: boolean; // new prop to control editor loading
    content?: string;    // new prop to set initial content
    setContent?: (value: string) => void; // new prop to update content
    templateId?: string | number; // template ID for AI generation
};

type _RouteParams = {
    templateId?: string;
};

const classNames = (...xs: Array<string | false | null | undefined>) =>
    xs.filter(Boolean).join(" ");


export type TextEditorViewRef = {};

const TextEditorView = forwardRef<TextEditorViewRef, EditorViewProps>(
    ({
        viewType = "editor",
        toggleView,
        editorView: _editorView,
        savedContent: _savedContent,
        loadEditor,
        content,
        setContent,
        templateId
    }, _ref) => {

        const customEditorRef = useRef<TextEditorRef>(null);


        return (
            <div
                className={classNames(
                    "editor-view",
                    "position-relative",
                    viewType !== "editor" && "visually-hidden"
                )}
            >       

                {loadEditor && (
                    <TextEditor
                        ref={customEditorRef}
                        content={content}
                        toggleView={toggleView}
                        setContent={setContent}
                        templateId={templateId}
                    />
                )}
            </div>
        );
    });

export default TextEditorView;
